export default () => ({
  items: [],
  types: [],
  pagination: [],
  item: {}
})
